import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import {Row , Col, Table, Panel} from 'react-bootstrap';
import TagsInput from 'react-tagsinput';
import { withRouter } from 'react-router';
import 'react-tagsinput/react-tagsinput.css';
import Autosuggest from 'react-autosuggest';

import { loginUser, logoutUser, registerUser } from '../actions/userActions';
import { fetchErrorsFilter, editError } from '../actions/errorActions';
import { fetchTagIds, fetchTagCounts } from '../actions/tagActions';

class ErrorEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      tag_list: [],
      subject: 0,
      tag_suggestions: [],
      error: null,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTagChange = this.handleTagChange.bind(this);
    this.setTags = this.setTags.bind(this);
  }

  setTags(error) {
    var subject_tags = this.props.tags.find(subject_tag=>parseInt(subject_tag.id,0)===parseInt(error.subject,0)).tags;
    var tags = this.state.tags;
    var tag_list = this.state.tag_list;
    error.tags.forEach((tag)=>{
      var hit_tag = subject_tags.find(t=>parseInt(t.key,0)===parseInt(tag,0));
      if (hit_tag !== null) {
        tags.push(hit_tag.value);
        tag_list.push(hit_tag.key);
      }
    });
    this.setState({tags: tags, tag_list: tag_list, });

    if (Object.keys(this.props.tags)!==0) {
      let hit_suggestions = this.props.tags.find(s=>parseInt(s.id,0)===parseInt(error.subject,0));
      if (hit_suggestions) {
        this.setState({tag_suggestions:hit_suggestions.tags})
      }
    }
  }

  componentDidMount() {
    var id = parseInt(this.props.match.params.id,0);
    let error = this.props.errors.find(err=>parseInt(err.id,0)===id);
    if (error) {
      this.setState({error:error});
      this.setTags(error);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (Object.keys(this.props.userinfo)!==0) {
      let error = this.state.error;
      let formData = new FormData();
      for (var key in error) {
        if (key.includes("_img")) {
          if (error[key]) { /* to do */
            if (document.getElementById(key).files.length !==0) {
              formData.append(key,error[key])
            }
          }  
        } else {
          if(error[key] && key!=='tags'){
            formData.append(key, error[key])
          }
        } 
      }
      var tmp_list = [];
      this.state.tag_list.forEach((tag)=>{
        tmp_list.push(parseInt(tag,0));
      });
      for (var i=0; i<tmp_list.length; i++){
        formData.append('tags',tmp_list[i]);
      }
      this.props.editError(this.props.userinfo.token,formData, error.id);
    } else {
      alert("请先登录");
      this.props.history.push(`/user_login`);
    }
  }

  handleCancel(event) {
    this.props.history.push(`/error/` + this.state.error.id + '/');
  }

  handleChange(event) {
    var error = this.state.error;
    if ((event.target.id) && (!event.target.id.includes('img'))) {
      const field = event.target.id;
      error[field] = event.target.value.trim();
      this.setState({error:error,})
    } else {
      if (event.target.id.includes('img')) {
        error[event.target.id] = event.target.files[0]
        this.setState({error:error,})
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (JSON.stringify(newProps.tags)!==JSON.stringify(this.props.tags)) {
      let ll = [];
      newProps.tags.forEach((tag)=>ll.push(tag.id));
      this.setState({tag_list:ll})
    }
    if (JSON.stringify(newProps.error)!==JSON.stringify(this.props.error)) {
      this.props.fetchErrorsFilter(this.props.userinfo.token,'id='+newProps.error.id);
      this.props.fetchTagCounts(this.props.userinfo.token);
      this.props.history.push(`/error/`+newProps.error.id);
      /*console.log('prev props error:'+this.props.error);
      console.log('new props error:'+newProps.error);*/
    }
  }

  handleTagChange(tags) {
    this.setState({tags});
    var tmpstr = this.state.error.subject + ' ';
    tags.forEach((t)=>{
     tmpstr = tmpstr + t + ' ';
    });
    this.props.fetchTagIds(this.props.userinfo.token,tmpstr);
  }

  onTagsChange(event) {
    this.setState({tags:event.target.value,})
  }

  render() {
    /* tag autocomplete */
    let tag_suggestions = this.state.tag_suggestions;
    function autocompleteRenderInput({addTag, ...props}) {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }
      const inputValue = (props.value && props.value.trim().toLowerCase()) || '';
      const inputLength = inputValue.length;
      let suggestions = [];
      if (tag_suggestions.length>0) {
        suggestions = tag_suggestions.filter((tag)=>{
          return tag.value.toLowerCase().slice(0, inputLength) === inputValue
        });
      }
      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value)=>value&&value.trim().length>0}
          getSuggestionValue={(suggestion)=>suggestion.value}
          renderSuggestion={(suggestion)=><span>{suggestion.value}</span>}
          inputProps={{...props,onChange:handleOnChange}}
          onSuggestionSelected={(e,{suggestion})=>{
            addTag(suggestion.value)
          }}
          onSuggestionsClearRequested={()=>{}}
          onSuggestionsFetchRequested={()=>{}}
        />
      )
    }

    var result = '';
    if (this.state.error !== null) {
      result =
        <Panel>
          <Panel.Heading>
            <h3>错题编辑</h3>
          </Panel.Heading>
          <Panel.Body>
          <div>
            <Row className="error">
              <form
                method="POST"
                encType="multipart/form-data"
                id="fileUploadForm"
              >

              <Col xs={12} md={4}>
                <div className="error" style={{border: "1px solid"}}>
                  <Table striped bordered condensed hover>
                  <tbody>
                    <tr><td>
                      <label>错题日期：
                        <input
                          id="ddate"
                          type="date"
                          value={this.state.error.ddate}
                          onChange={this.handleChange}
                        />
                       </label>
                    </td></tr>
                    <tr><td>
                      <label>错题来源：
                        <input
                          id="source"
                          type="text"
                          value={this.state.error.source}
                          onChange={this.handleChange}
                        />
                      </label>
                    </td></tr>
                    <tr><td>
                      <label>错题题型：
                        <input
                          id="question_type"
                          type="text"
                          value={this.state.error.question_type}
                          onChange={this.handleChange}
                        />
                      </label>
                    </td></tr>
                    <tr><td>
                      <label>错题原因：
                        <input
                          id="cause"
                          type="text"
                          value={this.state.error.cause?this.state.error.cause:''}
                          onChange={this.handleChange}
                        />
                      </label>
                    </td></tr>
                  </tbody>
                  </Table>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div className="error" style={{border: "1px solid", margin_left:"5px"}}>
                  <Table  striped bordered condensed hover>
                  <tbody>
                    <tr><td>
                      <label>错题描述<br/>
                      <textarea style={{width:"100%"}}
                        id="question_txt"
                        rows="4"
                        defaultValue={this.state.error.question_txt}
                        onChange={this.handleChange}
                      />
                    </label>
                    </td></tr>
                    <tr><td>
                        <label>错题图片1
                        <br/>
                        <img alt="" src={this.state.error.question_img1}/>
                    <input
                      type="file"
                      id="question_img1"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>错题图片2
                        <img alt="" src={this.state.error.question_img2}/>
                    <input
                      type="file"
                      id="question_img2"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>我的答案<br/>
                    <textarea
                      id="error_answer_txt"
                      rows="4"
                      cols="20"
                      onChange={this.handleChange}
                      defaultValue={this.state.error.error_answer_txt}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                        <label>我的答案图片1
                          <br/>
                          <img alt="" src={this.state.error.error_answer_img1}/>
                      <input
                        type="file"
                        id="error_answer_img1"
                        onChange={this.handleChange}
                      />
                    </label>
                    </td></tr>
                    <tr><td>
                        <label>我的答案图片2
                          <br/>
                          <img alt="" src={this.state.error.error_answer_img2}/>
                    <input
                      type="file"
                      id="error_answer_img2"
                      value=''
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>正确答案<br/>
                    <textarea
                      id="correct_answer_txt"
                      rows="4"
                      onChange={this.handleChange}
                      defaultValue={this.state.error.correct_answer_txt}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                        <label>正确答案图片1
                          <br/>
                          <img alt="" src={this.state.error.correct_answer_img1}/>
                    <input
                      type="file"
                      id="correct_answer_img1"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>正确答案图片2
                          <br/>
                          <img alt="" src={this.state.error.correct_answer_img2}/>
                    <input
                      type="file"
                      id="correct_answer_img2"
                      onChange={this.handleChange}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <label>答题思路<br/>
                    <textarea
                      id="method"
                      rows="4"
                      onChange={this.handleChange}
                      defaultValue={this.state.error.method}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                        <label>标签(输入后回车)<br/>
                    <TagsInput
                      value={this.state.tags}
                      onChange={this.handleTagChange}
                      renderInput={autocompleteRenderInput}
                    />
                    </label>
                    </td></tr>
                    <tr><td>
                    <input
                      type="button"
                      value="提交"
                      id="btnSubmit"
                      onClick={this.handleSubmit}
                    />
                    <input
                      type="button"
                      value="取消"
                      id="btnCancel"
                      onClick={this.handleCancel}
                    />
                    </td></tr>
                  </tbody>
                  </Table>
                </div>
              </Col>
              </form>
            </Row>
          </div>
          </Panel.Body>
        </Panel>
    } else {
      result = <div><p>No data found.</p></div>
    }
    return result
  }
}

ErrorEdit.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  editError: propsTypes.func.isRequired,
  fetchTagIds: propsTypes.func.isRequired,
  fetchErrorsFilter: propsTypes.func.isRequired,
  fetchTagCounts: propsTypes.func.isRequired,
  errors: propsTypes.list,
  error: propsTypes.object,
  userinfo: propsTypes.object,
  tags: propsTypes.list
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
  subjects: state.subjects.items,
  tags: state.tags.items,
  errors: state.errors.items,
  error: state.errors.item
})


export default withRouter(
  connect(
    mapStateToProps,{
      loginUser, 
      logoutUser, 
      registerUser, 
      editError,
      fetchErrorsFilter,
      fetchTagIds,
      fetchTagCounts
    }
  )(ErrorEdit)
);


// WEBPACK FOOTER //
// ./src/components/ErrorEdit.js